import { motion, AnimatePresence } from "framer-motion";

/**
 * Opening splash — logo scale-up + radial glow fade-in.
 * Dismisses automatically after ~800ms once the app mounts.
 */
export default function SplashScreen({ visible }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="splash-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
          className="fixed inset-0 z-[200] flex items-center justify-center"
          style={{ background: "#050505" }}
        >
          {/* radial glow fade-in */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "radial-gradient(circle at 50% 45%, rgba(124,58,237,0.35) 0%, rgba(16,185,129,0.15) 40%, transparent 70%)",
              filter: "blur(40px)",
            }}
          />
          <motion.img
            src="/rsell-logo.jpg"
            alt="rsell ai"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.55, ease: [0.2, 0.9, 0.2, 1] }}
            className="h-20 sm:h-24 w-auto relative"
            style={{ mixBlendMode: "screen" }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
